(function () {
  function run() {
    try {
      if (window.location.pathname.includes('/collections/vendors')) return;

      var container = document.querySelector('.breadcrumbs__list');
      if (!container) return;

      var allBreadCrumbLinks = container.querySelectorAll('a.breadcrumbs__link');
      if (!allBreadCrumbLinks || allBreadCrumbLinks.length === 0) return;

      if (!document.body) return;

      if (document.getElementById('breadcrumb-schema')) return;

      var schemaBreadCrumbsArray = [];

      for (var i = 0; i < allBreadCrumbLinks.length; i++) {
        var el = allBreadCrumbLinks[i];
        if (!el) continue;

        var ds = (el.dataset && el.dataset.schema) ? String(el.dataset.schema) : '';
        var name = ds.trim() ? ds.trim() : (el.innerText || '').trim();

        if (!name) continue;

        var item = el.href || '';
        if (!item) continue;

        schemaBreadCrumbsArray.push({
          '@type': 'ListItem',
          position: schemaBreadCrumbsArray.length + 1, 
          name: name,
          item: item
        });
      }

      if (schemaBreadCrumbsArray.length < 1) return;

      var breadCrumbsSchema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: schemaBreadCrumbsArray
      };

      var breadCrumbsScript = document.createElement('script');
      breadCrumbsScript.id = 'breadcrumb-schema';
      breadCrumbsScript.type = 'application/ld+json';
      breadCrumbsScript.text = JSON.stringify(breadCrumbsSchema);

      document.body.appendChild(breadCrumbsScript);
    } catch (e) {
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
